<template>
  <div v-if="tipsConfig.aboutToExpire" class="agreement-tips">
    <div class="tips-title">
      <i class="el-icon-warning"></i>
      代收代付协议到期提示
    </div>
    <div class="tips-content">
      <div>
        您与网约平台【{{ tipsConfig.orgName }}】签订的代收代付协议将于
        <span class="red-color">{{ tipsConfig.beforeEndDateDays }}</span>
        <span class="red-color">天</span>
        后 ({{ tipsConfig.endDate }}) 到期，为了不影响使用，请尽快联系平台并完成协议续签。
      </div>
    </div>
  </div>
</template>
<script setup>
import { checkWithholdContractDate } from '@/api/domain/contract'
import { reactive, watch } from 'vue'

const props = defineProps({
  formData: {
    type: Object,
    default: () => ({}),
  },
})

const tipsConfig = reactive({
  beforeEndDateDays: 0,
  endDate: '',
  aboutToExpire: false,
  orgName: '',
})

const getTipsConfig = async (formData) => {
  if (formData.licenceNo && formData.spId && formData.channelType) {
    const { code, data } = await checkWithholdContractDate({
      licenceNo: formData.licenceNo,
      spId: formData.spId,
      channelType: formData.channelType,
      orderId: formData.orderId,
    })
    if (code === 1) {
      tipsConfig.aboutToExpire = data.aboutToExpire
      tipsConfig.beforeEndDateDays = data.beforeEndDateDays
      tipsConfig.endDate = data.endDate
      tipsConfig.orgName = data.orgName
    }
  }
}

watch(() => props.formData.channelType, (val, oldVal) => {
  if (val !== oldVal) {
    getTipsConfig(props.formData)
  }
}, {
  immediate: true,
})
</script>
<style lang="scss" scoped>
.agreement-tips {
  background-color: #ECF3FF;
  color: #006AF5;
  padding: 10px 10px 10px 10px;
  border-radius: 5px;
  margin-bottom: 20px;
  .tips-title {
    color: #F2980B;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .red-color {
    color: red;
    font-weight: bold;
  }
}
</style>
